var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
import { Timeouts } from './framework/Timeouts';
import { TransportError } from './framework/Transport';
const modelInfo = {
    '-LwEqAiKpi7oDorsTNw1': { hasAutoSwitchVideoInputs: false },
    '-LwEqD4Gf6mUXtE0JAb1': { hasAutoSwitchVideoInputs: false },
    '-LwEqFYkNTto-qF1yGYz': { hasAutoSwitchVideoInputs: false },
    '-LwEqIEUROhfu907dK0_': { hasAutoSwitchVideoInputs: false },
    '-LwEqKPHG0mrn-aAtIuw': { hasAutoSwitchVideoInputs: false },
    '-LwEqMoHuRorKqxykYoO': { hasAutoSwitchVideoInputs: false },
    '-M3fUknk3B4UddFTEZD1': { hasAutoSwitchVideoInputs: false },
    '-M5d4hIz_WQWpBbjcChS': { hasAutoSwitchVideoInputs: false },
    '-MOYEXVlAjWXmghPKUdE': { hasAutoSwitchVideoInputs: false },
    '-MWiu8uYQ57BO-UysPfv': { hasAutoSwitchVideoInputs: false },
    '-MWiuFtaPay_eBjKtKle': { hasAutoSwitchVideoInputs: false },
    '-MlL3xmxZ4hV6dNRIsOY': { hasAutoSwitchVideoInputs: false },
    '-N0Gz4Sdauy80QGXon5b': { hasAutoSwitchVideoInputs: true },
    '-N0Gz4Se4Z0GPN1TAoLk': { hasAutoSwitchVideoInputs: true },
    '-OB6lw-ArhWnqWt6rU4f': { hasAutoSwitchVideoInputs: false }, // AT-OME-RX31
};
export class Atlona {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        this.log = log;
        // other class properties and constructor
        this.initializerSteps = [
            {
                errorCode: 'verifyFailed',
                send: 'PWSTA',
                next: /PW(?:ON|OFF)|Command Failed/i,
            },
        ];
        this.timeouts = new Timeouts();
        this.busyTimeout = this.timeouts.create();
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.firmwareVersion = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`Version`, /(?:firmware|version|v)?\s*([\d\.a-f]+)/i, tags);
                return match[1];
            }),
        };
        this.power = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`PWSTA`, /PW(.+)|Command Failed/i, tags);
                return match[1] ? match[1] === 'ON' : this.state.power.value;
            }),
            set: (value, tags) => __awaiter(this, void 0, void 0, function* () {
                yield this.socket.send(`PW${value ? 'ON' : 'OFF'}`, /PW(.+)/i, tags);
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), value ? 6000 : 1000);
                return value;
            }),
            asyncHandlers: {
                regExp: /PW(ON|OFF)/i,
                callback: (match) => {
                    this.state.power.update(match[1] === 'ON');
                },
            },
            hasControl: (config) => __awaiter(this, void 0, void 0, function* () {
                const tags = ['power.hasControl', 'initialize'];
                try {
                    const match = yield this.socket.send(`PWSTA`, /PW(.+)/i, tags);
                    return match[1] !== undefined;
                }
                catch (error) {
                    if (!(error instanceof TransportError) || error.code !== 'sendTimeout') {
                        throw error;
                    }
                    return false;
                }
            }),
        };
        this.videoMatrixRoutes = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`Status`, /x(\d+)AVx(\d+),?(.*)/i, tags);
                if (match[3]) {
                    // More than one response will have the form x1AVx2,x2AVx2; parse them all.
                    this.parseStatus(match[0]);
                    return this.state.videoMatrixRoutes.values[key];
                }
                else if (match[1]) {
                    return match[1];
                }
                return this.state.videoMatrixRoutes.values[key];
            }),
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), 1000);
                const match = yield this.socket.send(`x${value}AVx${key}`, /x(\d+)AVx(\d+)/i, tags);
                return match[1];
            }),
            asyncHandlers: {
                regExp: /x(\d+)AVx(\d+)/i,
                callback: (match) => {
                    const key = match[2];
                    const value = match[1];
                    this.state.videoMatrixRoutes.update(key, value);
                },
            },
        };
        // polling
        this.polls = [
            {
                intervalMs: 5000,
                controls: ['videoMatrixRoutes'],
            },
        ];
    }
    // phase callbacks
    onConfigure(config) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const info = modelInfo[(_a = config.modelNumber) !== null && _a !== void 0 ? _a : ''];
            if (info === undefined) {
                this.log.warning(`unrecognized model number: ${(_b = config.modelNumber) !== null && _b !== void 0 ? _b : ''}`);
            }
            if (info === null || info === void 0 ? void 0 : info.hasAutoSwitchVideoInputs) {
                yield this.socket.send(`AutoSW ${(config === null || config === void 0 ? void 0 : config.autoSwitchVideoInputs) ? 'on' : 'off'}`, /AutoSW (on|off)/i, ['set.autoSwitchVideoInputs', 'configuring']);
            }
        });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield CommandSocketInitializer.initialize(this.socket, this.initializerSteps, credentials);
        });
    }
    // other class methods
    parseStatus(ack) {
        const responses = ack.split(',');
        const regExp = /x(\d+)AVx(\d+)/i;
        for (const resp of responses) {
            const match = resp.match(regExp);
            if (match && match[0]) {
                this.state.videoMatrixRoutes.update(match[2], match[1]);
            }
        }
    }
}
// static properties
Atlona.driverType = 'socketDriver';
Atlona.key = '-LwEpli5F-pAkqai069c';
Atlona.baseSocketOptions = {
    commandExtractor: {
        terminators: ['\r', '\n'],
    },
    sendTerminator: '\r',
    sendTimeoutMs: 3000, // Some commands are responding just after 2 seconds
};
Atlona.socketOptions = [
    Object.assign(Object.assign({}, Atlona.baseSocketOptions), { port: 23 }),
    Object.assign(Object.assign({}, Atlona.baseSocketOptions), { port: 4999 }),
];
